import { __assign, __rest } from "tslib";
import React, { useState, forwardRef } from "react";
import { nanoid } from "nanoid";
import { Select } from "../Select";
import { FormField } from "./FormField";
export var FormSelect = forwardRef(function (_a, ref) {
    var label = _a.label, id = _a.id, errorLabel = _a.errorLabel, helpLabel = _a.helpLabel, className = _a.className, inputProps = __rest(_a, ["label", "id", "errorLabel", "helpLabel", "className"]);
    var uid = useState(id || nanoid(8))[0];
    return (React.createElement(FormField, { label: label, htmlFor: uid, errorLabel: errorLabel, helpLabel: helpLabel, className: className },
        React.createElement(Select, __assign({ id: uid, ref: ref }, inputProps))));
});
//# sourceMappingURL=FormSelect.js.map